export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ця дія назавжди видалить актив"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви впевнені, що хочете продовжити?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Так"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скасувати"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви більше не побачите цей актив у своєму списку."])}
}